import React, { useState, useEffect } from "react";
import { changeSessionTime } from "../../services/adminTimeTableServices";
import { extractLocalTime, buildLocalDateTime } from "../../../utils/dateTimeUtils";
import DurationTimePicker, { computeEndTime } from "./DurationTimePicker";

const ChangeSessionTimeModal = ({ session, dayDate, onClose, reload }) => {
  const [startClock,   setStartClock]   = useState("");
  const [durationHrs,  setDurationHrs]  = useState(0);
  const [durationMins, setDurationMins] = useState(30);
  const [loading, setLoading] = useState(false);

  const endClock = computeEndTime(startClock, durationHrs, durationMins);

  useEffect(() => {
    if (!session) return;
    const st = extractLocalTime(session.startTime);
    const et = extractLocalTime(session.endTime);
    setStartClock(st);
    if (st && et) {
      const [sh, sm] = st.split(":").map(Number);
      const [eh, em] = et.split(":").map(Number);
      const diff = (eh * 60 + em) - (sh * 60 + sm);
      setDurationHrs(Math.floor(diff / 60));
      setDurationMins(diff % 60);
    }
  }, [session]);

  const handleSubmit = async () => {
    if (!startClock) return alert("Please provide a start time");
    setLoading(true);
    try {
      await changeSessionTime(
        session.id,
        buildLocalDateTime(dayDate, startClock),
        buildLocalDateTime(dayDate, endClock)
      );
      reload();
      onClose();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to update session time");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tt-modal-overlay" onClick={onClose}>
      <div className="tt-modal" style={{ width: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="tt-modal-header">
          <h3>Change Session Time</h3>
          <button className="tt-drawer-close" onClick={onClose}>✕</button>
        </div>
        <div className="tt-modal-body">
          <DurationTimePicker
            startTime={startClock}
            durationHrs={durationHrs}
            durationMins={durationMins}
            endTime={endClock}
            onStartChange={setStartClock}
            onDurationChange={(h, m) => { setDurationHrs(h); setDurationMins(m); }}
          />
        </div>
        <div className="tt-modal-footer">
          <button className="adm-btn adm-btn-ghost" onClick={onClose}>Cancel</button>
          <button className="adm-btn adm-btn-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? "Updating…" : "Update Time"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeSessionTimeModal;
